module.exports = __webpack_public_path__ + "img/Privacy.bc1cb77a.svg";